<div class="min-h-screen bg-slate-50 p-6 md:p-12">
  <!-- Header Section -->
  <div class="max-w-5xl mx-auto mb-12">
    <div class="flex items-center gap-4 mb-2">
      <div class="w-1.5 h-10 bg-[#c19725] rounded-full"></div>
      <h1 class="text-3xl font-black text-gray-800 tracking-tight uppercase">GST Configuration Hub</h1>
    </div>
    <p class="text-gray-500 font-medium ml-6">Manage your digital presence and communication preferences</p>
  </div>

  <!-- Options Grid -->
  <div class="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
    
    <div *ngFor="let option of settingsOptions" 
         class="group relative bg-white rounded-[2rem] p-8 shadow-sm border border-gray-100 transition-all duration-300 hover:shadow-2xl hover:-translate-y-2 overflow-hidden">
      
      <!-- Background Decoration (Large Ghost Icon) -->
      <div class="absolute -right-6 -top-6 opacity-[0.05] group-hover:scale-120 group-hover:-rotate-12 transition-all duration-700">
        <i [class]="option.icon" class="text-[12rem]"></i>
      </div>

      <div class="relative z-10">
        <!-- Icon Header -->
        <div [ngClass]="option.color" class="w-16 h-16 rounded-2xl flex items-center justify-center mb-6 shadow-inner transition-transform group-hover:scale-110 duration-500">
          <i [class]="option.icon + ' ' + option.iconColor" style="font-size: 30px;"></i>
        </div>

        <!-- Content -->
        <h2 class="text-2xl font-black text-gray-800 mb-3 group-hover:text-[#c19725] transition-colors">
          {{ option.title }}
        </h2>
        <p class="text-gray-500 leading-relaxed mb-8 min-h-[60px]">
          {{ option.description }}
        </p>

        <!-- Action Button -->
        <a [routerLink]="option.link" 
           [ngClass]="option.buttonClass"
           class="inline-flex items-center justify-center px-8 py-3.5 text-white font-bold rounded-xl transition-all active:scale-95 shadow-lg shadow-black/5">
          Configure Now
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-2 group-hover:translate-x-2 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
          </svg>
        </a>
      </div>

      <!-- Footer Accent -->
      <div class="absolute bottom-0 left-0 right-0 h-1.5 bg-[#c19725] translate-y-full group-hover:translate-y-0 transition-transform"></div>
    </div>

  </div>

  <!-- Simple Branding Footer -->
  <div class="max-w-5xl mx-auto mt-16 text-center">
    <p class="text-gray-400 text-xs font-bold uppercase tracking-[0.3em]">Professional GST Management System</p>
  </div>
</div>